<template>
  <b-row>
    <b-col>
      <chartjs-container :title="ChartTitle">
        <chartjs-component-horizontal-bar-chart v-if="ChartHasMeaningfulData"
                                                :height="chartHeight" :chart-data="ChartData" />
        <p v-else>
          Aucune donnée disponible pour la période sélectionnée.
        </p>
      </chartjs-container>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCol,
  BRow,
} from 'bootstrap-vue'
import { convertHM } from '@/@core/utils/filter'
import ChartjsContainer from '../ChartjsContainer.vue'
import ChartjsComponentHorizontalBarChart from '../charts-components/ChartjsComponentHorizontalBarChart.vue'
import useStatisticsRouteFetch from '../useStatisticsRouteFetch'
import {
  computedConfiguration,
  watchConfiguration,
  BASE_CHART_HEIGHT,
  chartHasMeaningfulData,
  CHART_COLORS,
  TABS,
} from './baseConfiguration'

export default {
  components: {
    BCol,
    BRow,
    ChartjsContainer,
    ChartjsComponentHorizontalBarChart,
  },
  data() {
    return {
      tabname: TABS.VOLUNTEERSHOURS,
      ChartTitle: 'Temps alloué par les bénévoles',
      ChartData: {},
      chartHeight: BASE_CHART_HEIGHT,
    }
  },
  computed: {
    ChartHasMeaningfulData() {
      return chartHasMeaningfulData(this.ChartData)
    },
    ...computedConfiguration,
  },
  watch: watchConfiguration,
  methods: {
    fetchRouteOnActive() {
      if (this.active) {
        this.fetchRoute()
      }
    },
    async fetchRoute() {
      const response = await useStatisticsRouteFetch()
      if (response && Array.isArray(response)) {
        const sortedData = [...response].sort((a, b) => b.labelValue.value - a.labelValue.value)
        this.chartHeight = Math.max(sortedData.length * 40, BASE_CHART_HEIGHT)
        this.ChartData = {
          labels: sortedData.map(item => `${item.labelValue.label} (${convertHM(item.labelValue.value)})`),
          datasets: [{
            label: 'Nombre d\'heures',
            data: sortedData.map(item => item.labelValue.value),
            backgroundColor: CHART_COLORS.BRAND.SECONDARY,
          }],
        }
      }
    },
  },
}
</script>
